<div class="row">
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
    <div class="card">
      <div class="row">
        <div class="col-4 d-flex align-items-center">
          <h3 class="card-title text-nowrap">{{ 'general.info' | translate }}</h3>
        </div>
        <div class="col-8 d-flex justify-content-end">
          <div class="flex-gap-5">
            <form-row-checkbox
              [inputDisabled]="!isBundleCanBeSet"
              [label]="'product.isBundle'"
              [(model)]="productDetailService.product.isBundle"
              [dataCySelector]="'product-is-bundle'"
            ></form-row-checkbox>
            <form-row-checkbox
              [label]="'product.enabled'"
              [(model)]="productDetailService.product.enabled"
              [dataCySelector]="'product-enabled'"
            >
            </form-row-checkbox>
          </div>
        </div>
      </div>
      <div class="card-body p-0 row">
        <div class="col-12 mt-2">
          <form-row-input
            [label]="'product.name'"
            [icon]="'far-file-alt'"
            [(model)]="productDetailService.product.name"
            [required]="!productDetailService.product.name"
            [requiredCssClass]="productDetailService.submitted && !productDetailService.product.name"
            [dataCyAttribute]="'product-name'"
          ></form-row-input>
        </div>
        <div class="col-12">
          <form-row-select-multiple
            [label]="'tags'"
            [options]="queryTags.data()"
            [selectedValues]="selectedTags()"
            (selectedValuesChange)="onTagsChange($event)"
            [isTags]="true"
            [dataCyAttribute]="'product-tags'"
          ></form-row-select-multiple>
        </div>
        <div class="col-6">
          <form-row-input
            [label]="'product.ean'"
            [icon]="'far-barcode'"
            [translateBarcode]="true"
            [(model)]="productDetailService.product.ean"
            [appendBtnIcon]="
              !productDetailService.product.ean || productDetailService.product.ean?.length === 0 ? 'fa-barcode' : ''
            "
            [appendBtnLabel]="
              !productDetailService.product.ean || productDetailService.product.ean?.length === 0
                ? 'product.ean.generate'
                : ''
            "
            [appendBtnClasses]="['btn-ean']"
            (onAppendBtnEvent)="fillNextEan()"
            [dataCyAttribute]="'product-ean'"
          ></form-row-input>
          @if (!!productDetailService.product.ean2 || !!productDetailService.product.ean) {
            <form-row-input
              [label]="'product.ean2'"
              [icon]="'fa-barcode'"
              [(model)]="productDetailService.product.ean2"
              [translateBarcode]="true"
              [dataCyAttribute]="'product-ean2'"
            ></form-row-input>
          }
          @if (!!productDetailService.product.ean3 || !!productDetailService.product.ean2) {
            <form-row-input
              [label]="'product.ean3'"
              [icon]="'fa-barcode'"
              [(model)]="productDetailService.product.ean3"
              [translateBarcode]="true"
            ></form-row-input>
          }
          @if (!!productDetailService.product.ean4 || !!productDetailService.product.ean3) {
            <form-row-input
              [label]="'product.ean4'"
              [icon]="'fa-barcode'"
              [(model)]="productDetailService.product.ean4"
              [translateBarcode]="true"
            ></form-row-input>
          }
          @if (!!productDetailService.product.ean5 || !!productDetailService.product.ean4) {
            <form-row-input
              [label]="'product.ean5'"
              [icon]="'fa-barcode'"
              [(model)]="productDetailService.product.ean5"
              [translateBarcode]="true"
            ></form-row-input>
          }
        </div>
        <div class="col-6">
          <form-row-input
            [label]="'product.code'"
            [icon]="'far-tag'"
            [(model)]="productDetailService.product.code"
            [appendBtnIcon]="
              !productDetailService.product.code || productDetailService.product.code?.length === 0 ? 'fa-barcode' : ''
            "
            [appendBtnLabel]="
              !productDetailService.product.code || productDetailService.product.code?.length === 0
                ? 'product.code.generate'
                : ''
            "
            [appendBtnClasses]="['btn-ean']"
            (onAppendBtnEvent)="fillNextCode()"
            [dataCyAttribute]="'product-code'"
          ></form-row-input>
          @if (!!productDetailService.product.code2 || !!productDetailService.product.code) {
            <form-row-input
              [label]="'product.code2'"
              [icon]="'far-tag'"
              [(model)]="productDetailService.product.code2"
              [dataCyAttribute]="'product-code2'"
            ></form-row-input>
          }
          @if (!!productDetailService.product.code3 || !!productDetailService.product.code2) {
            <form-row-input
              [label]="'product.code3'"
              [icon]="'far-tag'"
              [(model)]="productDetailService.product.code3"
              [dataCyAttribute]="'product-code3'"
            ></form-row-input>
          }
        </div>
        <div class="col-12">
          <form-row-select
            [icon]="'far-industry'"
            [label]="'brand'"
            [model]="productDetailService.product.producer?.id"
            (modelChange)="productDetailService.product.producer = { id: $event, name: '' }"
            [options]="productDetailService.queryProducers.data()"
            [dataCyAttribute]="'product-producer-select'"
          ></form-row-select>
        </div>
        <div class="col-12">
          <div class="form-group">
            <form-row-textarea
              [label]="'note'"
              [icon]="null"
              [(model)]="productDetailService.product.note"
              [dataCyAttribute]="'product-note'"
            ></form-row-textarea>
          </div>
        </div>
        <div class="col-12 d-flex align-items-center">
          <form-row-checkbox
            [label]="'product.isForSubsequentSettlement'"
            [(model)]="productDetailService.product.isForSubsequentSettlement"
            [tooltipLabel]="'isForSubsequentSettlement.info'"
            [dataCySelector]="'product-isForSubsequentSettlement'"
          ></form-row-checkbox>
        </div>
        <div class="col-12 d-flex align-items-center">
          <form-row-checkbox
            [label]="'product.isPML'"
            [(model)]="productDetailService.product.isPML"
            [tooltipLabel]="'isPML.info'"
            [dataCySelector]="'product-isPML'"
          ></form-row-checkbox>
        </div>
        <div class="col-12 d-flex align-items-center">
          <form-row-checkbox
            [label]="'product.isAdultOnly'"
            [(model)]="productDetailService.product.isAdultOnly"
            [tooltipLabel]="'isAdultOnly.info'"
            [dataCySelector]="'product-isAdultOnly'"
          ></form-row-checkbox>
        </div>
        @if (productDetailService.product.externalId) {
          <div class="col-12">
            <div class="flex-gap-5 align-items-center">
              <div class="card-subheading">{{ 'externalId' | translate }}:</div>
              <div style="font-size: 14px">
                {{ productDetailService.product.externalId }}
              </div>
            </div>
          </div>
        }
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5">
        <div class="card">
          <div class="row">
            <div class="col-8">
              <h3 class="card-title text-nowrap">{{ 'sellPrice' | translate }}</h3>
            </div>
            <div class="col-4">
              @if (productDetailService.product.children && productDetailService.product.children.length) {
                <btn
                  [title]="'insert.values.into.variants'"
                  [classes]="['btn-third', 'btn-sm', 'float-right']"
                  [icon]="'far-chevron-right'"
                  (onEvent)="updateVariants(['sellPrice', 'beforeSellPrice'])"
                >
                </btn>
              }
            </div>
          </div>
          <div class="row mt-2">
            <div class="col">
              <form-row-input
                [label]="'product.price.sale'"
                [class]="'input-unit'"
                [icon]="'fa-money-bill'"
                [(model)]="productDetailService.product.sellPrice"
                [required]="!productDetailService.product?.sellPrice"
                [replaceComma]="true"
                [appendUnitCurrency]="true"
                [dataCyAttribute]="'product-price-sale'"
              ></form-row-input>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <form-row-input
                [label]="'product.price.before'"
                [class]="'input-unit'"
                [icon]="'fa-money-bill-alt'"
                [(model)]="productDetailService.product.beforeSellPrice"
                [replaceComma]="true"
                [appendUnitCurrency]="true"
                [dataCyAttribute]="'product-price-before'"
              ></form-row-input>
            </div>
          </div>
          <div class="row">
            <div class="col">
              @if (productDetailService.queryVats.data()?.length > 0 && productDetailService.queryVats.data()[0].id) {
                <form-row-select
                  [label]="'product.vatrate'"
                  [options]="productDetailService.queryVats.data()"
                  [model]="vat"
                  (modelChange)="productDetailService.product.vat.id = $event"
                  [dataCyAttribute]="'product-vat'"
                ></form-row-select>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7">
        <div class="card">
          <div class="row">
            <div class="col-8">
              <h3 class="card-title">{{ 'productMoves.load.list' | translate }}</h3>
            </div>
            <div class="col-4">
              @if (productDetailService.product?.children?.length) {
                <btn
                  [classes]="['btn-third', 'btn-sm', 'float-right']"
                  [icon]="'far-chevron-right'"
                  (onEvent)="updateVariants(['purchasePrice', 'purchaseCurrency', 'supplier'])"
                >
                </btn>
              }
            </div>
          </div>
          <div class="row mt-2">
            <div class="col">
              <form-row-input
                [label]="'purchasePrice.default'"
                [class]="'input-unit'"
                [icon]="'fa-money-bill'"
                [(model)]="productDetailService.product.purchasePrice"
                [replaceComma]="true"
                [dataCyAttribute]="'product-price-default'"
              ></form-row-input>
            </div>
            <div class="col">
              <form-row-select
                [label]="'currency.default'"
                [icon]="'far-coins'"
                [model]="productDetailService.product.purchaseCurrency?.id"
                (modelChange)="productDetailService.product.purchaseCurrency = { id: $event, name: '', ratio: 1 }"
                [options]="productDetailService.queryCurrencies.data()"
                [dataCyAttribute]="'product-currency-select'"
              ></form-row-select>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <form-row-select
                [model]="productDetailService.product.supplier?.id"
                (modelChange)="setSupplier($event)"
                [label]="'supplier.default'"
                [icon]="'fa-person-carry'"
                [options]="productDetailService.querySuppliers.data()"
                [dataCyAttribute]="'product-supplier-select'"
              ></form-row-select>
            </div>
          </div>
          @if (!productDetailService.product.isBundle && isEnabledModule) {
            <div class="row pt-2">
              <div class="col">
                <form-row-checkbox
                  [(model)]="productDetailService.product.requiredSerialNumbers"
                  [label]="'product.requiredSerialNumbers'"
                  [dataCySelector]="'product-requiredSerialNumbers'"
                ></form-row-checkbox>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
    <div class="row">
      <div class="col-12">
        <!--        <div class="card" *ngIf="!productDetailService.product.isBundle">-->
        <div class="card">
          <div class="row">
            <div class="col-6 align-self-center">
              <label class="card-title text-nowrap">
                {{ 'product.parent' | translate }}
              </label>
            </div>
            <div class="col-6 d-flex flex-row-reverse">
              <modal-product-parent
                [product]="productDetailService.product"
                [depots]="productDetailService.queryDepotsOptions.data()"
                [suppliers]="productDetailService.querySuppliers.data()"
                [btnText]="'product.choose'"
                [dataCySelector]="'product-parent-button'"
                (result)="setParent($event)"
              ></modal-product-parent>
            </div>
          </div>
          @if (productDetailService.product?.parent?.id > 0) {
            <div class="mt-2" data-cy="product-parent">
              <table class="table">
                <tbody>
                  <div class="table-product-border">
                    <tr>
                      <td class="border-0 td-left-radius w-100">
                        <div class="flex-gap-10 align-items-center">
                          <product-image [product]="productDetailService.product.parent"></product-image>
                          <div>
                            <a class="link-bold" [routerLink]="['/product', productDetailService.product.parent.id]">{{
                              productDetailService.product.parent.fullName
                            }}</a>
                            <div class="product-details flex-gap-5 flex-wrap">
                              @if (productDetailService.product.parent.code) {
                                <div>
                                  {{ 'product.code' | translate }}: {{ productDetailService.product.parent.code }}
                                </div>
                              }
                              @if (productDetailService.product.parent.ean) {
                                <div>
                                  {{ 'product.ean' | translate }}: {{ productDetailService.product.parent.ean }}
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </td>
                      <td class="border-0 td-right-radius">
                        <btn
                          [title]="'delete' | translate"
                          [icon]="'far-trash-alt'"
                          [classes]="['btn-trash', 'btn-sm', 'float-right']"
                          (onEvent)="productDetailService.product.parent = null"
                          [dataCyAttribute]="'remove-product-parent-button'"
                        ></btn>
                      </td>
                    </tr>
                  </div>
                </tbody>
              </table>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        @if (!productDetailService.product.isBundle && !productDetailService.isCreating) {
          <div class="card">
            <div>
              <div class="row">
                <div class="col-5 d-flex align-items-center">
                  <label class="card-title">{{ 'product.children' | translate }}</label>
                </div>
                <div class="col-7 d-flex flex-row-reverse">
                  <btn
                    [routerLink]="['/product-variant-create', productDetailService.product.id]"
                    [classes]="['btn-first']"
                    [label]="'variant.create'"
                    [title]="'variant.create' | translate"
                    [dataCyAttribute]="'variant-create-button'"
                  ></btn>
                  <modal-product-parent
                    class="me-2"
                    [product]="productDetailService.product"
                    [depots]="productDetailService.queryDepotsOptions.data()"
                    [suppliers]="productDetailService.querySuppliers.data()"
                    [btnText]="'variant.choose'"
                    (result)="addChild($event)"
                    [dataCySelector]="'variant-choose-modal'"
                  ></modal-product-parent>
                </div>
              </div>
              @if (productDetailService.product.children && productDetailService.product.children.length > 0) {
                <table class="table mt-2">
                  <tbody class="images" [photoGalleryGroup]="{ index: 1 }">
                    @for (child of productDetailService.product.children; track child) {
                      <tr>
                        <td>
                          <div class="flex-gap-10">
                            @if (child.mainImage) {
                              <div
                                class="align-self-center"
                                [photoGallery]="child.mainImage?.url"
                                [photoGalleryCaption]="
                                  child.fullName +
                                  '<br>' +
                                  (child.code ? ('product-form.code' | translate) + child.code : '') +
                                  '<br>' +
                                  (child.ean ? ('product-form.ean' | translate) + child.ean : '')
                                "
                              >
                                <div class="images-item">
                                  @if (!!child.mainImage?.url?.length && !!child.mainImage?.thumbnails?.length) {
                                    <img
                                      class="images-item-image"
                                      [src]="getThumbUrl(child.mainImage)"
                                      [alt]="child.fullName"
                                    />
                                  }
                                  @if (!child.mainImage?.url?.length || !child.mainImage?.thumbnails?.length) {
                                    <img
                                      class="images-item-image"
                                      [src]="'assets/img/no-image.png'"
                                      [alt]="child.fullName"
                                    />
                                  }
                                </div>
                              </div>
                            }
                            <div class="align-self-center">
                              @if (!!child) {
                                <a
                                  class="link-bold"
                                  [routerLink]="['/product', child.id]"
                                  data-cy="product-variant-link"
                                >
                                  {{ child.name }}
                                </a>
                              }
                              <div class="product-details flex-gap-5 flex-wrap">
                                @if (child.code) {
                                  <div>{{ 'product.code' | translate }}: {{ child.code }}</div>
                                }
                                @if (child.ean) {
                                  <div>{{ 'product.ean' | translate }}: {{ child.ean }}</div>
                                }
                              </div>
                            </div>
                          </div>
                        </td>
                        <td title="Skladovost" class="text-center">
                          <modal-stock-overview
                            [isCalculatedOfProductDepots]="true"
                            [isSumCalculated]="true"
                            [product]="child"
                            [depots]="productDetailService.queryDepotsOptions.data()"
                            [suppliers]="productDetailService.querySuppliers.data()"
                          >
                          </modal-stock-overview>
                        </td>
                        <td>
                          <btn
                            [title]="'remove' | translate"
                            [icon]="'far-trash-alt'"
                            [classes]="['btn-trash', 'btn-sm', 'float-right']"
                            (onEvent)="removeChild(child)"
                          ></btn>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              }
            </div>
          </div>
        }
        @if (productDetailService.product.bundleParents && productDetailService.product.bundleParents.length > 0) {
          <div class="card">
            <div>
              <div class="row">
                <div class="col card-title align-self-center">
                  {{ 'products.bundleParents' | translate }}
                </div>
              </div>
              <table class="table mt-2">
                <tbody>
                  @for (bp of productDetailService.product.bundleParents; track bp) {
                    <tr>
                      <td class="ps-1">
                        <div class="flex-gap-10 align-items-center" [photoGalleryGroup]="{ index: 2 }">
                          <div
                            [photoGallery]="bp.parent.mainImage?.url"
                            [photoGalleryCaption]="
                              bp.parent.fullName +
                              '<br>' +
                              (bp.parent.code ? ('product.code' | translate) + bp.parent.code : '') +
                              '<br>' +
                              (bp.parent.ean ? ('product.ean' | translate) + bp.parent.ean : '')
                            "
                          >
                            <div class="images-item">
                              @if (!!bp.parent.mainImage?.url?.length && !!bp.parent.mainImage?.thumbnails?.length) {
                                <img
                                  class="images-item-image"
                                  [src]="getThumbUrl(bp.parent.mainImage)"
                                  [alt]="bp.parent.fullName"
                                />
                              }
                              @if (!bp.parent.mainImage?.url?.length || !bp.parent.mainImage?.thumbnails?.length) {
                                <img
                                  class="images-item-image"
                                  [src]="'assets/img/no-image.png'"
                                  [alt]="bp.parent.fullName"
                                />
                              }
                            </div>
                          </div>
                          @if (!!bp.parent && !productDetailService.isCreating) {
                            <a class="link-bold" [routerLink]="['/product', bp.parent.id]">{{ bp.parent.fullName }}</a>
                          }
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
        <!--          // todo bundle parent:D-->

        @if (productDetailService.product.isBundle) {
          <div class="card">
            <div class="row">
              <div class="col card-title align-self-center">
                {{ 'products.bundleChildren' | translate }}
              </div>
              <div class="col d-flex flex-row-reverse">
                <modal-product-parent
                  [product]="productDetailService.product"
                  [depots]="productDetailService.queryDepotsOptions.data()"
                  [suppliers]="productDetailService.querySuppliers.data()"
                  [isForBundleChild]="true"
                  [dataCySelector]="'product-bundle-child-button'"
                  [btnText]="'item.choose'"
                  (result)="addBundleChild($event)"
                ></modal-product-parent>
              </div>
            </div>
            <table class="table mt-2">
              <tbody>
                @for (bc of productDetailService.product.bundleChildren; track bc) {
                  <tr>
                    <td class="fixed-column-width" data-cy="bundle-child-quantity">{{ bc.quantity }}x</td>
                    <td class="ps-0">
                      <div class="flex-gap-10 align-items-center" [photoGalleryGroup]="{ index: 3 }">
                        <div
                          [photoGallery]="bc.child.mainImage?.url"
                          [photoGalleryCaption]="
                            bc.child.fullName +
                            '<br>' +
                            (bc.child.code ? ('product.code' | translate) + bc.child.code : '') +
                            '<br>' +
                            (bc.child.ean ? ('product.ean' | translate) + bc.child.ean : '')
                          "
                        >
                          <div class="images-item">
                            @if (!!bc.child.mainImage?.url?.length && !!bc.child.mainImage?.thumbnails?.length) {
                              <img
                                class="images-item-image"
                                [src]="getThumbUrl(bc.child.mainImage)"
                                [alt]="bc.child.fullName"
                              />
                            }
                            @if (!bc.child.mainImage?.url?.length || !bc.child.mainImage?.thumbnails?.length) {
                              <img
                                class="images-item-image"
                                [src]="'assets/img/no-image.png'"
                                [alt]="bc.child.fullName"
                              />
                            }
                          </div>
                        </div>
                        <div>
                          @if (!!bc.child) {
                            <a class="link-bold" [routerLink]="['/product', bc.child.id]">{{ bc.child.fullName }}</a>
                          }
                          <div class="product-details flex-gap-5 flex-wrap">
                            @if (bc.child.code) {
                              <div>{{ 'product.code' | translate }}: {{ !!bc.child ? bc.child.code : '' }}</div>
                            }
                            @if (bc.child.ean) {
                              <div>{{ 'product.ean' | translate }}: {{ !!bc.child ? bc.child.ean : '' }}</div>
                            }
                          </div>
                        </div>
                      </div>
                    </td>
                    @if (!!bc.child) {
                      <td class="text-center text-nowrap" title="Skladovost">
                        <modal-stock-overview
                          [isCalculatedOfProductDepots]="true"
                          [isSumCalculated]="true"
                          [product]="bc.child"
                          [depots]="productDetailService.queryDepotsOptions.data()"
                          [suppliers]="productDetailService.querySuppliers.data()"
                        >
                        </modal-stock-overview>
                      </td>
                    }
                    <td>
                      <div class="d-flex justify-content-end">
                        <modal-product-parent
                          [productBundle]="bc"
                          [product]="productDetailService.product"
                          [depots]="productDetailService.queryDepotsOptions.data()"
                          [suppliers]="productDetailService.querySuppliers.data()"
                          [dataCySelector]="'product-bundle-child-edit-button'"
                          (result)="updateBundleChild($event)"
                        ></modal-product-parent>
                        <btn
                          [title]="'delete' | translate"
                          [icon]="'far-trash-alt'"
                          [classes]="['btn-trash', 'btn-sm', 'float-right']"
                          [dataCyAttribute]="'product-bundle-child-delete'"
                          (onEvent)="removeBundleChild(bc)"
                        ></btn>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card" style="padding-left: 25px">
          <div class="row">
            <div class="col-8 ps-0">
              <h3 class="card-title">
                {{ 'logistic.details' | translate }}
              </h3>
            </div>
            <div class="col-4">
              @if (productDetailService.product.children && productDetailService.product.children.length) {
                <btn
                  [classes]="['btn-third', 'btn-sm', 'float-right']"
                  [icon]="'far-chevron-right'"
                  (onEvent)="
                    updateVariants([
                      'dimensionX',
                      'dimensionY',
                      'dimensionZ',
                      'weight',
                      'originCountry',
                      'hsCode',
                      'isFragile',
                      'isOversize'
                    ])
                  "
                >
                </btn>
              }
            </div>
          </div>

          <app-product-logistic-details
            [product]="productDetailService.product"
            (productChange)="productDetailService.product = $event"
          ></app-product-logistic-details>

          <div class="row mt-2">
            <div class="col-12 d-flex justify-content-start ps-0">
              <div class="flex-gap-10">
                <form-row-checkbox
                  [label]="'fragile'"
                  [(model)]="productDetailService.product.isFragile"
                  [dataCySelector]="'product-is-fragile'"
                >
                </form-row-checkbox>
                <form-row-checkbox
                  [label]="'oversize'"
                  [(model)]="productDetailService.product.isOversize"
                  [dataCySelector]="'product-is-oversize'"
                >
                </form-row-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="card">
        <h2 class="card-title">{{ 'short.description' | translate }}</h2>
        @if (ckeditor && ckeditorConfig) {
          <ckeditor
            class="mt-3"
            [editor]="ckeditor"
            [config]="ckeditorConfig"
            [(ngModel)]="productPerex"
            [ngModelOptions]="{ standalone: true }"
            data-cy="product-description"
          ></ckeditor>
        } @else {
          @if (ckeditorLoading) {
            <div class="ckeditor-placeholder mt-3" aria-hidden="true"></div>
          }
          @if (ckeditorLoadError) {
            <textarea
              class="form-control ckeditor-fallback mt-3"
              rows="6"
              [(ngModel)]="productPerex"
              [ngModelOptions]="{ standalone: true }"
              data-cy="product-description"
            ></textarea>
          }
        }
      </div>
    </div>
    <div class="row">
      <div class="card">
        <h2 class="card-title">{{ 'long.description' | translate }}</h2>
        @if (ckeditor && ckeditorConfig) {
          <ckeditor
            class="mt-3"
            [editor]="ckeditor"
            [config]="ckeditorConfig"
            [(ngModel)]="productDescription"
            [ngModelOptions]="{ standalone: true }"
            data-cy="product-description"
          ></ckeditor>
        } @else {
          @if (ckeditorLoading) {
            <div class="ckeditor-placeholder mt-3" aria-hidden="true"></div>
          }
          @if (ckeditorLoadError) {
            <textarea
              class="form-control ckeditor-fallback mt-3"
              rows="8"
              [(ngModel)]="productDescription"
              [ngModelOptions]="{ standalone: true }"
              data-cy="product-description"
            ></textarea>
          }
        }
      </div>
    </div>
  </div>
</div>
